module.exports = __webpack_public_path__ + "c93be15f2cde269ce245b1154969c436.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/arrow-black.svg
// module id = 2396
// module chunks = 0